export const LANGUAGE = 'es';

export const URL = 'https://es.wikipedia.org/w/api.php';

export const ACTION_QUERY = '?action=query';

export const CORS_HEAD = '&origin=*';

export const WIKI_LESBIAN = 'Lesbianas';

export const FORMAT_JSON = '&format=json';

export const HISTORY_ARTICLES_WIKIPEDIA = [
  `Lesbianismo`,
  `Cultura_lesbiana`,
  `Historia_del_lesbianismo`,
  `Utopía_lésbica`,
  `Homofobia`,
  `Día de la Visibilidad Lésbica`,
  `Lesbianismo político`,
];

export const FLEXCENTER = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};
